const manutencao_de_tipo_de_servico = {
  path: "/manutencao-de-tipo-de-servico",
  redirect: "/manutencao-de-tipo-de-servico",
  meta: {
    breadCrumb: "Processo de Matrículas - Transferência do Aluno",
  },
  children: [
    {
      path: "/manutencao-de-tipo-de-servico",
      name: "manutencao_de_tipo_de_servico",
      component: () =>
        import(
          "@/views/ManutencaoDeTipoDeServico/ManutencaoDeTipoDeServicoHome.vue"
        ),
    },
    {
      path: "/manutencao-de-tipo-de-servico/:id",
      name: "manutencao_de_tipo_de_servico_edit",
      component: () =>
        import(
          "@/views/ManutencaoDeTipoDeServico/ManutencaoDeTipoDeServicoEdit.vue"
        ),
    },
    {
      path: "/manutencao-de-tipo-de-servico/novo",
      name: "manutencao_de_tipo_de_servico_cad",
      component: () =>
        import(
          "@/views/ManutencaoDeTipoDeServico/ManutencaoDeTipoDeServicoCad.vue"
        ),
    },
  ],
};

export { manutencao_de_tipo_de_servico };
